/* eslint-disable */
const API_URL = import.meta.env.VITE_API_URL;
const BASE = `${API_URL}/api/baiboon`;

async function request(path, options = {}) {
  const { headers, ...restOptions } = options;
  const res = await fetch(`${BASE}${path}`, {
    ...restOptions,
    headers: { 'Content-Type': 'application/json', ...headers },
  });
  const text = await res.text();
  let json = null;
  if (text) {
    try {
      json = JSON.parse(text);
    } catch {
      json = null;
    }
  }
  if (!res.ok || (json && json.success === false)) {
    const err = new Error(json?.message || `เกิดข้อผิดพลาด (${res.status})`);
    err.status = res.status;
    err.errors = json?.errors;
    throw err;
  }
  return json || { success: true };
}

function authHeader(token) {
  return { authorization: token };
}

export async function sendChat(token, message) {
  return request('/chat', {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify({ message }),
  });
}

export async function getChatHistory(token, { limit = 30, before } = {}) {
  const params = new URLSearchParams();
  if (limit) params.set('limit', String(limit));
  if (before) params.set('before', String(before));
  const q = params.toString() ? `?${params.toString()}` : '';
  return request(`/chat/history${q}`, { headers: authHeader(token) });
}

export async function listFaq(token, { search = '', page = 1, limit = 25 } = {}) {
  const params = new URLSearchParams();
  if (search) params.set('search', search);
  if (page) params.set('page', String(page));
  if (limit) params.set('limit', String(limit));
  const q = params.toString() ? `?${params.toString()}` : '';
  return request(`/faq${q}`, { headers: authHeader(token) });
}

export async function getFaq(token, id) {
  return request(`/faq/${encodeURIComponent(id)}`, { headers: authHeader(token) });
}

export async function createFaq(token, body) {
  return request('/faq', {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify(body),
  });
}

export async function teachFaq(token, body) {
  return request('/faq/teach', {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify(body),
  });
}

export async function previewImportFaqs(token, items) {
  return request('/faq/import/preview', {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify({ items }),
  });
}

export async function importFaqs(token, items, { duplicateMode = 'skip' } = {}) {
  return request('/faq/import', {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify({ items, duplicateMode }),
  });
}

export async function updateFaq(token, id, body) {
  return request(`/faq/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: authHeader(token),
    body: JSON.stringify(body),
  });
}

export async function deleteFaq(token, id) {
  return request(`/faq/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: authHeader(token),
  });
}

export async function listUnanswered(token, status = 'pending') {
  const q = status ? `?status=${encodeURIComponent(status)}` : '';
  return request(`/unanswered${q}`, { headers: authHeader(token) });
}

export async function resolveUnanswered(token, id, body) {
  return request(`/unanswered/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: authHeader(token),
    body: JSON.stringify(body),
  });
}

export async function getStats(token) {
  return request('/stats', { headers: authHeader(token) });
}

export async function getBaiboonSettings(token) {
  return request('/settings', { headers: authHeader(token) });
}

export async function updateBaiboonSettings(token, body) {
  return request('/settings', {
    method: 'PUT',
    headers: authHeader(token),
    body: JSON.stringify(body),
  });
}

export async function purgeBaiboonChat(token, months = 12) {
  return request('/maintenance/purge-chat', {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify({ months }),
  });
}

export async function cleanupBaiboonMedia(token) {
  return request('/maintenance/cleanup-media', {
    method: 'POST',
    headers: authHeader(token),
    body: JSON.stringify({}),
  });
}

export const DEFAULT_BAIBOON_CHIPS = [
  'วันลาคงเหลือ',
  'ยอดหักเงินค้ำ',
  'ดูตารางกะ',
  'ประวัติเบิกโอที',
  'ผลประเมิน',
  'ประวัติสุขภาพ',
];

export const DEFAULT_BAIBOON_CHIPS_UNMATCHED = [
  'วันลาคงเหลือ',
  'ดูตารางกะ',
  'จัดกะรอบนี้',
  'ยอดหักเงินค้ำ',
];

export async function uploadBaiboonMedia(token, file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${BASE}/media`, {
    method: 'POST',
    headers: authHeader(token),
    body: fd,
  });
  const text = await res.text();
  let json = null;
  if (text) {
    try {
      json = JSON.parse(text);
    } catch {
      json = null;
    }
  }
  if (!res.ok || (json && json.success === false)) {
    const err = new Error(json?.message || `อัปโหลดไม่สำเร็จ (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return json || { success: true };
}

export const FAQ_CATEGORIES = ['วันลา', 'การเงิน', 'สวัสดิการ', 'ฝึกอบรม', 'ความปลอดภัย', 'ทั่วไป'];

export const FAQ_STATUS = {
  active: { label: 'เผยแพร่', color: 'success' },
  draft: { label: 'แบบร่าง', color: 'default' },
};

export const UNANSWERED_STATUS = {
  pending: { label: 'รอเพิ่ม prompt', color: 'error' },
  resolved: { label: 'สอนบอทแล้ว', color: 'success' },
  dismissed: { label: 'ปิดแล้ว', color: 'default' },
};
